import { createCustomFilterForEntity } from "@shared/backend/create-custom-filter-for-entity";
import {
  filterWithRelationsAndJson,
  type RelationalOrJsonEntityFilter,
} from "@shared/helpers/sql-relations";
import { CallCenterShiftTask } from "./entity";

const createCustomFilter = createCustomFilterForEntity<CallCenterShiftTask>();

export class CallCenterShiftTaskFilters {
  static hyperFilter = createCustomFilter<
    RelationalOrJsonEntityFilter<CallCenterShiftTask>
  >((filters) => {
    return filterWithRelationsAndJson(CallCenterShiftTask)(filters);
  });
}
